<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">
          （<span>{{ regulations.time }}</span>
          数据来源：国家文物局博物馆与社会文物司）
          <button id="btn" @click="btn()">
            <span class="spn1" v-show="textList.bloc == false"></span
            ><span class="spn2" v-show="textList.bloc == false"></span> 展开
          </button>
        </p>
        <div
          v-show="textList.disappear"
          style="padding-top: 20px"
          class="text"
          v-html="opList"
        ></div>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入通报国"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging"></div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              type="index"
              :index="count"
              label="序号"
              width="60"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="countryName"
              label="通报国"
              min-width="200px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="reportTime"
              label="通报时间"
              min-width="230px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="crNum"
              label="通报文物数量"
              min-width="268px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="url"
              label="附件下载"
              min-width="290px"
            >
              <template slot-scope="scope">
                <a v-if="scope.row.url" :href="scope.row.url">点击下载</a>
                <span v-else>暂无附件</span>       
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import { URL_DESCRIPTION_FIND } from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      pagesize: 20,
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "外国被盗文物数据库",
        // 浏览次数
        num: "2",
        // 更新时间
        time: "",
      },
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],
      // 前往页数
      currentPage: 1,
      // 总条数
      total: 100,
      //  文本内容
      textList: {
        // 显示隐藏
        disappear: false,
        // 开关
        num: true,
        // 箭头
        bloc: true,
      },
      opList: null,
    };
  },
  computed: {},
  methods: {
    getList() {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        keyWord: this.searchOn,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.post(Url + `/api/foreign/lose/find`, params).then((res) => {
        if (res.status === 200) {
          this.total = res.data.data.recordsTotal;
          this.legalForms = res.data.data.data;
        }
      });
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataForeignLoseCr"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataForeignLoseCr",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] = "DataForeignLoseCr";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
          this.opList = res.data.data.remake;
        }
      });
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn =null;
      this.currentPage = 1;
      this.pagesize = 20;
      this.getList();
    },
    // 解决换页后index从1开始
    count(index) {
      return (this.currentPage - 1) * this.pagesize + index + 1;
    },

    refresh() {
      this.resetOn();
    },
    // 表格分页
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 展开收起
    btn() {
      if (this.textList.num == true) {
        this.textList.disappear = true;
        document.getElementById("btn").innerHTML = "收起";
        this.textList.num = false;
        this.textList.bloc = false;
      } else {
        this.textList.disappear = false;
        document.getElementById("btn").innerHTML = "展开";
        this.textList.num = true;
        this.textList.bloc = true;
      }
    },
  },
  mounted() {
    this.getList();
    this.getNumberViews();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";
a {
  color: #4b74ff !important ;
  font-size: 12px;
  text-decoration: underline;
}
#btn {
  width: 75px;
  height: 31px;
  border-radius: 5%;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-color: #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  span {
    display: inline-block;
    border: 5px solid transparent;
    position: absolute;
  }
  .spn1 {
    border-bottom-color: #606266;
    left: 10px;
  }
  .spn2 {
    border-top-color: #606266;
    left: 10px;
    top: 13px;
  }
}
#btn:hover {
  border-color: @theme-color;
  background-color: @background-color;
  color: @theme-color;
}
#btn:hover .spn1 {
  border-bottom-color: @theme-color;
}
#btn:hover .spn2 {
  border-top-color: @theme-color;
}
.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}
.province {
  width: 170px;
}
.batch {
  width: 150px;
}
.dat {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  align-items: center;
}
.text {
  font-size: 16px;
}
</style>